import { inject, type InjectionKey, type Plugin } from "vue";
import type { HTTPService } from ".";

export const HTTP_SYMBOL: InjectionKey<HTTPService> = Symbol();

export function createHttp(service: HTTPService): Plugin {
	return {
		install(app) {
			app.provide(HTTP_SYMBOL, service);
		},
	};
}

export const useHTTP = () => {
	const http = inject(HTTP_SYMBOL);
	if (!http) throw new Error("http service not found in app instance");

	return http;
};
